import Base from 'base.service';

export default class Registration extends Base {
  constructor($http) {
    'ngInject';
    super($http);
  }

  sendRequest(requestData) {
    return this.$http.post(`${this.pingstaApiUrl}/registrations.json`, requestData);
  }
}



// WEBPACK FOOTER //
// ./src/app/screens/guest/screens/registration/util/registration.service.js